import { Component, OnInit, ViewChild, ElementRef, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { AuthStore } from 'src/app/stores/auth/auth.store';
import { DataService } from 'src/app/services/data.service';
import { ConvertService } from 'src/app/services/convert.service';
import { GENDERS, DISPLAY_STATUS_OBJECT, STATUS_OBJECT } from 'src/app/dummy/status';
import { ITrainingStudent } from 'src/app/interfaces/training';
import { TrainingStore } from 'src/app/stores/training/training.store';
import { FireStorageService } from 'src/app/services/fire-storage.service';

@Component({
  selector: 'app-add-training-student',
  templateUrl: './add-training-student.component.html',
  styleUrls: ['./add-training-student.component.scss']
})
export class AddTrainingStudentComponent implements OnInit {
  @ViewChild('focusInput', {static:false}) inputEl: ElementRef;
   @ViewChild('photoFile',{static:false}) photoFile: ElementRef;

  form: FormGroup;

  processNew: boolean = false;
  processClose: boolean = false;
  error: any = null;
  isCreate: boolean = false;
  TITLE = 'Add new student';
  GENDER: any = GENDERS;
  ITEM: ITrainingStudent;
  START_UPLOAD: boolean;
  uploadPercent: any;
  SELECTED_PICTURE_FILE: any;
  imageSrc: string;

  constructor(
    public dialogRef: MatDialogRef<AddTrainingStudentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private auth: AuthStore,
    public store: TrainingStore,
    private snackBar: MatSnackBar,
    private ds: DataService,
    private storage: FireStorageService,
  ) { }

  ngOnInit() {
    const { STUDENT } = this.data;
    this.ITEM = STUDENT || null;
    this.form = this.fb.group({
      firstName: [STUDENT ? STUDENT.firstName : null, Validators.compose([Validators.required])],
      lastName: [STUDENT ? STUDENT.lastName : null, Validators.compose([Validators.required])],
      gender: [STUDENT ? STUDENT.gender : GENDERS[0], Validators.compose([Validators.required])],
      dateOfBirth: [STUDENT ? STUDENT.dateOfBirth.toDate() : new Date(), Validators.compose([Validators.required])],
      phoneNumber: [STUDENT ? STUDENT.phoneNumber : null, Validators.compose([Validators.required])],
      email: [STUDENT ? STUDENT.email : null,],

    })
    if (STUDENT) {
      this.TITLE = "Edit student";
    }
  }

  compareWithObj(a: any, b: any): boolean {
    if (b) return a.key === b.key;
  }


  async uploadFilePicture(event) {
    if (event && event.target.files.length > 0) {
      this.SELECTED_PICTURE_FILE = event.target.files[0];
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.imageSrc = e.target.result;
      };
      reader.readAsDataURL(event.target.files[0]);
      if (this.ITEM) {
        //PICTURE
        this.START_UPLOAD = true;
        const file = this.SELECTED_PICTURE_FILE;
        const fileName = file.name;
        const uploadPath = `students/${this.ITEM.key}/${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        this.ITEM.photoFileDetail = files;
        this.store.save(this.ITEM, (success, res) => {
          if (success) {
            this.snackBar.open("Student has been saved successful.", "Done", { duration: 2500 });
          }
          this.processNew = false;
          this.processClose = false;
          this.SELECTED_PICTURE_FILE = null;
          this.START_UPLOAD = false;
          this.imageSrc = null;
          this.photoFile.nativeElement.value = "";
        })
      }
    }
  }


  async onSave(f: any, isDraft: boolean, isNew: boolean) {
    this.processClose = isDraft ? false : true;
    this.processNew = isDraft;
    this.error = null;
    this.isCreate = true;
    if (this.form.valid) {
      this.form.disable();
      const { firstName, lastName, phoneNumber, dateOfBirth, email, gender } = f;
      const { STUDENT, TESTING_ACCOUNT } = this.data;
      const { user, selectedCompanyKey } = this.auth;
      const registerStatus = STATUS_OBJECT.submitted;
      const item: ITrainingStudent = {
        key: STUDENT ? STUDENT.key : this.ds.createId(),
        status: DISPLAY_STATUS_OBJECT.ACTIVE,
        isDelete: false,
        created_at: STUDENT ? STUDENT.created_at : new Date(),
        created_by: STUDENT ? STUDENT.created_by : user.uid,
        updated_at: new Date(),
        updated_by: user.uid,
        date_key: STUDENT ? STUDENT.date_key : ConvertService.dateKey(),
        page_key: ConvertService.pageKey(),
        keyword: ConvertService.toCapitalize(`${firstName} ${lastName} ${phoneNumber} ${email}`),
        organizationRef: selectedCompanyKey ? this.ds.companyRef().doc(selectedCompanyKey).ref : null,
        organizationKey: selectedCompanyKey || null,
        created_byRef: STUDENT ? STUDENT.created_byRef : this.ds.userProfileRef().doc(user.uid).ref,
        updated_byRef: this.ds.userProfileRef().doc(user.uid).ref,
        register_status: registerStatus,
        dateOfBirth,
        firstName,
        lastName,
        fullName: `${firstName} ${lastName}`,
        email,
        phoneNumber,
        gender: gender,
        placementTestStarting: TESTING_ACCOUNT || false,
        photoFileDetail: STUDENT.photoFileDetail || null,
      }
      if (this.SELECTED_PICTURE_FILE) {
        this.START_UPLOAD = true;
        const file = this.SELECTED_PICTURE_FILE;
        const fileName = file.name;
        const uploadPath = `students/${item.key}/${fileName}`;
        const uploadTask = this.storage.uploadSelectedFile(file, uploadPath);
        this.uploadPercent = uploadTask.percentageChanges();
        const files = await this.storage.getFileDetail(file, uploadPath, uploadTask)
        item.photoFileDetail = files;
        this.START_UPLOAD = false;
      }
      this.store.save(item, (success, res) => {
        if (success) {
          this.snackBar.open("Student has been saved successful.", "Done", { duration: 1000 });
          if (!isNew || STUDENT) {
            this.dialogRef.close('no')
            return;
          }
          this.form.reset();
          this.form.enable();
          this.processNew = false;
          this.processClose = false;
          this.isCreate = false;
          this.SELECTED_PICTURE_FILE = null;
          this.imageSrc = null;
          this.photoFile.nativeElement.value = "";
          this.inputEl.nativeElement.focus()
        }

      })
    }
    else {
      this.processNew = false;
      this.processClose = false;
      this.isCreate = false;
    }
  }
}